/**
 * timeFormat
 *
 * @param {number} time in milliseconds
 * @returns {number} - the formatted time
 */
export function timeFormat(time) {
  return (parseInt(time / 100, 10) / 10).toFixed(2); // eslint-disable-line no-magic-numbers
}
